module.exports = __webpack_public_path__ + "img/moto.dcda8e78.svg";